exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.activity-iframe-wrap[data-v-5f3fbd2e]{width:100%;height:calc(100vh - 53px - 40px)\n}\n", "", {"version":3,"sources":["/data/jenkins/workspace/shop/src/pages/r4SettlementReport/activity/index.vue"],"names":[],"mappings":";AAkCA,uCACE,WACA,gCAAiC;CAClC","file":"index.vue","sourcesContent":["\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n.activity-iframe-wrap {\n  width: 100%;\n  height: calc(100vh - 53px - 40px);\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5f3fbd2e","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/r4SettlementReport/activity/index.vue
// module id = JWiZ
// module chunks = 2